import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd, Event as NavigationEvent } from '@angular/router';

import { Cookie } from 'ng2-cookies/ng2-cookies';
import { TranslateService } from 'ng2-translate';
import { Subscription } from 'rxjs';
import { Observable } from 'rxjs/Rx';
import * as CryptoJS from 'crypto-js';

import { AuthService } from '../shared/services/auth.service';
import { ProjectsService } from './work/services/projects.service';
import { SpinnerService } from '../shared/services/spinner.service';
import { CookieManagerService } from '../shared/services/cookie-manager.service';

import { MainConstants } from './main.const';
import { Constants } from './../app.const';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html'
})
export class MainComponent implements OnInit {

  pageTitle: string;
  routeUrl: string;
  selectedFlag: string;
  selectedLanguage: string;
  power: string;
  activeKey: string;
  subscription: Subscription;
  header: string;
  subHeader: string;
  token: string;
  userDetails: any = {};
  mainConstants: any = MainConstants;
  constants: any = Constants;
  active: boolean;
  isClient: boolean;
  static staticSpinner: any;

  constructor(
    private router: Router,
    private translate: TranslateService,
    private activatedRoute: ActivatedRoute,
    private authService: AuthService,
    private spinner: SpinnerService,
    private cookieManagerService: CookieManagerService,
    private projectsService: ProjectsService,

  ) {
    spinner.status.subscribe((status: boolean) => {
      this.active = status;
    });
    this.setLanguage(MainConstants.lanEn);

    this.navigationPermissions = this.navigationPermissions.bind(this);
  }

  ngOnInit() {
    this.getAuthUserDetials();
  }

  isCorrectUrl(url: string) {
    if (!this.routeUrl) return false;
    return this.routeUrl.includes(url) ? true : false
  }

  setLanguage(lang: string) {
    this.translate.use(lang);
    this.cookieManagerService.setCookie(MainConstants.LANG, lang, false, 1);
    this.selectLanguage(lang);
  }

  setSelectedLanguage(lang: string) {
    this.translate.use(lang);
    this.selectLanguage(lang);
  }

  isCurrentLang(lang: string) {
    // check if the selected lang is current lang
    return lang === this.translate.currentLang;
  }

  selectLanguage(lang: string) {
    if (lang === MainConstants.lanEn) {
      this.selectedFlag = MainConstants.lanFlagEn;
      this.selectedLanguage = MainConstants.lanViewEn;
    } else {
      this.selectedFlag = MainConstants.lanFlagSw;
      this.selectedLanguage = MainConstants.lanViewSw;
    }
  }

  /**
   * logout api call,
   * remove token
   */
  signOut() {
    this.authService.signOut();
  }

  /**
   * get authenticate user details
   */
  getAuthUserDetials() {
    this.projectsService.getAuthUserDetials().subscribe(
      res => {
        this.userDetails = res.data;
        let value = CryptoJS.AES.encrypt(JSON.stringify(this.userDetails), MainConstants.basicConstans.userKey).toString();
        this.cookieManagerService.setCookie(MainConstants.basicConstans.userToken, value, false, 1);
        this.navigationPermissions();
      }
    );
  }

  navigationPermissions(){
    if(this.userDetails.is_client){
      this.isClient = true;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/main.component.ts